import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
  TextField,
  Box,
  CircularProgress,
  MenuItem,
  Select,
  FormControl,
  InputLabel,
  Typography,
} from '@mui/material';
import PercentIcon from '@mui/icons-material/Percent';

interface BulkVatRateUpdateDialogProps {
  open: boolean;
  loading: boolean;
  selectedCount: number;
  vatRate: number;
  onVatRateChange: (value: number) => void;
  onConfirm: () => void;
  onCancel: () => void;
}

// Türkiye'deki yaygın KDV oranları
const VAT_RATE_OPTIONS = [0, 1, 8, 10, 18, 20];

export const BulkVatRateUpdateDialog: React.FC<BulkVatRateUpdateDialogProps> = ({
  open,
  loading,
  selectedCount,
  vatRate,
  onVatRateChange,
  onConfirm,
  onCancel,
}) => {
  return (
    <Dialog open={open} onClose={loading ? undefined : onCancel} maxWidth="xs" fullWidth>
      <DialogTitle sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
        <PercentIcon color="primary" />
        Toplu KDV Oranı Güncelleme
      </DialogTitle>
      <DialogContent>
        <DialogContentText sx={{ mb: 3 }}>
          <strong>{selectedCount}</strong> ürünün KDV oranını güncellemek üzeresiniz.
        </DialogContentText>
        
        <Box sx={{ mt: 2 }}>
          <FormControl fullWidth>
            <InputLabel>KDV Oranı</InputLabel>
            <Select
              value={vatRate}
              label="KDV Oranı"
              onChange={(e) => onVatRateChange(Number(e.target.value))}
              disabled={loading}
            >
              {VAT_RATE_OPTIONS.map((rate) => (
                <MenuItem key={rate} value={rate}>
                  %{rate}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          
          <Typography variant="caption" color="text.secondary" sx={{ mt: 1, display: 'block' }}>
            Veya manuel olarak girin:
          </Typography>
          
          <TextField
            fullWidth
            type="number"
            label="KDV Oranı (%)"
            value={vatRate}
            onChange={(e) => onVatRateChange(Number(e.target.value))}
            disabled={loading}
            inputProps={{ min: 0, max: 100, step: 1 }}
            sx={{ mt: 1 }}
            InputProps={{
              endAdornment: <Typography color="text.secondary">%</Typography>
            }}
          />
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={onCancel} disabled={loading}>
          İptal
        </Button>
        <Button
          onClick={onConfirm}
          variant="contained"
          color="primary"
          disabled={loading}
          startIcon={loading ? <CircularProgress size={20} /> : null}
        >
          {loading ? 'Güncelleniyor...' : `${selectedCount} Ürünü Güncelle`}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default BulkVatRateUpdateDialog;

